/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectHouseId } from 'shared/selectors/houseInfo';
import { selectFilters } from 'shared/selectors/marketTrends/selectFilters';
import { fetchMarketTrends } from 'shared/services/fetchMarketTrends';
import { setMarketTrends, setMarketTrendsStatus } from 'shared/slices/marketTrends';
import { EMarketTrendsStatus } from 'shared/types/marketTrends';
import { IThunkApi } from 'shared/types/redux';

export const getMarketTrendsData = createAsyncThunk<void, void, IThunkApi>(
  'marketTrends/getMarketTrendsData',
  async (_, thunkApi) => {
    const { getState, extra: context, dispatch } = thunkApi;

    const state = getState();
    const houseId = selectHouseId(state);
    const filters = selectFilters(state);

    dispatch(setMarketTrendsStatus(EMarketTrendsStatus.Loading));

    const newMarketTrends = await fetchMarketTrends(context, { parameters: { realtyId: houseId, ...filters } });

    /* istanbul ignore else */
    if (newMarketTrends) {
      dispatch(setMarketTrends(newMarketTrends));
    }

    dispatch(setMarketTrendsStatus(EMarketTrendsStatus.Loaded));
  },
);
